import './App.css';
import Sidebar from './Sidebar';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Clothing from './pages/Clothing';
import Income from './pages/Income';
import Expense from './pages/Expense';
import Investment from './pages/Investment';
import Accessories from './pages/Accessories';
import Reminder from './pages/Reminder';
import Dashboard from './pages/Dashboard';
import Habits from './pages/Habits';
import Notes from './pages/Notes';
import NotePage from './pages/NotePage';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa'; // Add this import
import NoteFolder from './pages/NoteFolder'; // Add this import
import Diary from './pages/Diary'; // Add this import
import Events from './pages/Events'; // Add this import
import Secrets from './pages/Secrets'; // Add this import
import Drive from './pages/Drive'; // Add this import
import Tweek from './pages/Tweek'; // Add this import
import Routine from './pages/Routine'; // Add this import
import { Provider } from 'react-redux';
import store from './store';
import { ShortcutProvider } from './context/ShortcutContext';

const ProtectedLayout = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth(); // Add isLoading
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  
  // Add loading check
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Mobile Header */}
      <div className="sticky top-0 z-40 lg:hidden">
        <div className="flex items-center justify-between bg-white px-4 py-3 shadow-md">
          <button
            onClick={toggleSidebar}
            className="inline-flex items-center justify-center p-2 text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {isSidebarOpen ? (
              <FaTimes className="w-6 h-6" />
            ) : (
              <FaBars className="w-6 h-6" />
            )}  
          </button>
          <div className="text-lg font-semibold text-gray-800">Asset Manager</div>
          <div className="w-10"></div> {/* Spacer for centering */}
        </div>
      </div>

      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Main Content */}
      <main className={`transition-all duration-300 lg:ml-8 ${isSidebarOpen ? 'ml-0' : 'ml-0'} mt-14 lg:mt-0`}>
        <div className="p-4 lg:p-6 lg:px-8 xl:px-12">
          {children}
        </div>
      </main>
    </div>
  );
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      
      {/* Protected Routes */}
      <Route path="/" element={<ProtectedLayout><Dashboard /></ProtectedLayout>} />
      <Route path="/dashboard" element={<ProtectedLayout><Dashboard /></ProtectedLayout>} />
      <Route path="/clothing" element={<ProtectedLayout><Clothing /></ProtectedLayout>} />
      <Route path="/income" element={<ProtectedLayout><Income /></ProtectedLayout>} />
      <Route path="/expense" element={<ProtectedLayout><Expense /></ProtectedLayout>} />
      <Route path="/investment" element={<ProtectedLayout><Investment /></ProtectedLayout>} />
      <Route path="/accessories" element={<ProtectedLayout><Accessories /></ProtectedLayout>} />
      <Route path="/reminder" element={<ProtectedLayout><Reminder /></ProtectedLayout>} />
      <Route path="/habits" element={<ProtectedLayout><Habits /></ProtectedLayout>} />
      <Route path="/notes" element={<ProtectedLayout><Notes /></ProtectedLayout>} />
      <Route path="/drive" element={<ProtectedLayout><Drive /></ProtectedLayout>} /> {/* Add this line */}
      <Route path="/notes/folder/:folderId" element={<ProtectedLayout><NoteFolder /></ProtectedLayout>} />
      <Route path="/notes/folder/:folderId/note/:noteId" element={<ProtectedLayout><NotePage /></ProtectedLayout>} />
      <Route path="/diary" element={<ProtectedLayout><Diary /></ProtectedLayout>} />
      <Route path="/events" element={<ProtectedLayout><Events /></ProtectedLayout>} />
      <Route path="/secrets" element={<ProtectedLayout><Secrets /></ProtectedLayout>} />
      <Route path="/tweek" element={<ProtectedLayout><Tweek /></ProtectedLayout>} /> {/* Add this line */}
      <Route path="/routine" element={<ProtectedLayout><Routine /></ProtectedLayout>} /> {/* Add this line */}
      
      {/* Catch all route */}
      <Route path="*" element={
        <ProtectedLayout>
          <Navigate to="/dashboard" replace />
        </ProtectedLayout>
      } />
    </Routes>
  );
}

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AuthProvider>
          <ShortcutProvider>
            <AppRoutes />
          </ShortcutProvider>
        </AuthProvider>
      </Router>
    </Provider>
  );
}

export default App;
